export default __webpack_public_path__ + "static/media/instagram-glyph-gradient.7618c0ff.png";